<template>
  <div class="studentApply">
    <div class="flag">
      <div
        @click="setTabIndex(1)"
        :class="tabFlag == 1 ? 'on ' : ' '"
        class="bor"
      >
        新学员报名
      </div>
      <div
        @click="setTabIndex(2)"
        :class="tabFlag == 2 ? 'on ' : ' '"
        class="bor"
      >
        老学员报名
      </div>
    </div>
    <div v-if="tabFlag == 1">
      <div class="list">
        <div class="input_class">
          <div class="name">学员姓名</div>
          <Input
            type="text"
            placeholder="请输入姓名"
            class="sizegap"
            required
            v-model="adultStudent.name"
            style="width:200px"
          />
        </div>

        <div class="input_class">
          <div class="name">学员性别</div>
          <Select
            name="sex"
            id=""
            class="sizegap"
            v-model="adultStudent.sex"
            style="width:200px"
          >
            <Option value="0">请选择学员性别</Option>
            <Option value="1">男</Option>
            <Option value="2">女</Option>
          </Select>
        </div>

        <div class="input_class">
          <div class="name">学员生日</div>
          <Date-picker
            type="date"
            placeholder="选择生日"
            style="width: 200px"
            v-model="adultStudent.birthday"
            class="Date-picker"
            @on-change="birthdayType"
          ></Date-picker>
        </div>

        <div class="input_class">
          <div class="name">家长关系</div>
          <Select
            name="store_id"
            id=""
            class="sizegap"
            v-model="adultStudent.relation"
            style="width:200px"
          >
            <Option
              :value="item"
              v-for="(item, index) in relationList"
              :key="index"
              >{{ item }}</Option
            >
          </Select>
        </div>

        <div class="input_class">
          <div class="name">手机号码</div>
          <Input
            type="text"
            placeholder="请输入手机号码"
            class="sizegap"
            required
            v-model="adultStudent.phone"
            style="width:200px"
          />
        </div>

        <div class="input_class">
          <div class="name">报名课程</div>
          <Select
            name="product_id"
            id=""
            class="sizegap"
            style="width:200px"
            v-model="adultStudent.pid"
          >
            <Option value="0">请选择课程</Option>
            <Option
              :value="item.id"
              v-for="item in productList"
              :key="item.id"
              >{{ item.store_name }}</Option
            >
          </Select>
        </div>

        <button class="submit" @click="adultSubmit">提交</button>
      </div>
    </div>

    <div v-if="tabFlag == 2">
      <div class="list">
        <div class="input_class">
          <div class="name">学员姓名</div>
          <Select
            name="product_id"
            id=""
            class="sizegap"
            style="width:200px"
            v-model="childStudent.sid"
          >
            <Option value="0">请选择学员</Option>
            <Option
              :value="item.Id"
              v-for="item in studentList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </div>

        <div class="input_class">
          <div class="name">报名课程</div>
          <Select
            name="product_id"
            id=""
            class="sizegap"
            style="width:200px"
            v-model="childStudent.pid"
          >
            <Option value="0">请选择课程</Option>
            <Option
              :value="item.id"
              v-for="item in productList"
              :key="item.id"
              >{{ item.store_name }}</Option
            >
          </Select>
        </div>

        <button class="submit" @click="childSubmit">提交</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.flag {
  display: flex;
}
.bor {
  flex: 1;
  height: 0.8rem;
  font-size: 0.3rem;
  text-align: center;
  line-height: 0.8rem;
}
.on {
  background: #2980f7;
  color: #fff;
}
.input_class {
  background-color: #fff;
  margin-top: 0.2rem;
  display: flex;
  align-items: center;
}
.input_class div {
  font-size: 0.3rem;
}
.sizegap {
  font-size: 32rpx;
  padding-left: 0.6rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
.name {
  margin-left: 0.1rem;
}
.remark {
  background-color: #ccc;
  border-radius: 0.1rem;
  padding-left: 0.1rem;
  margin-left: 0.3rem;
}
.submit {
  margin: 0.5rem 0;
  margin-left: 50%;
  transform: translate(-50%, 0);
  width: 3.5rem;
  background: #2980f7;
  height: 0.7rem;
  font-size: 0.4rem;
  color: #fff;
  font-weight: 700;
  border-radius: 0.3rem;
}
.Date-picker {
  margin-left: 0.5rem;
}
</style>

<script>
import {
  getLesson,
  postSignUser,
  addStudent,
  getstudentInfo,
  oldBuyLesson
} from "@api/user";

export default {
  name: "StudentApply",
  data: function() {
    return {
      tabFlag: 1,
      adultStudent: {
        name: "",
        sex: "0",
        birthday: "",
        relation: "请选择家长",
        phone: "",
        pid: "0",
        user_id: 0
      },

      childStudent: {
        sid: "0",
        pid: "0"
      },
      storeList: [],
      productList: [],
      relationList: ["请选择家长", "爸爸", "妈妈", "爷爷", "奶奶"],
      classList: [],
      userInfo: {},
      studentList: []
    };
  },
  methods: {
    setTabIndex(e) {
      this.tabFlag = e;
      if (e == 2) {
        this.getStudentlist();
      }
    },
    adultSubmit (e) {
      this.adultStudent.user_id = this.userInfo.uid;
      var _this = this;
      if (!this.adultStudent.phone)
        return this.$dialog.toast({ mes: "缺少手机号" });
      if (!this.adultStudent.name)
        return this.$dialog.toast({ mes: "缺少姓名" });
      if (!this.adultStudent.sex)
        return this.$dialog.toast({ mes: "请选择性别" });
      addStudent(this.adultStudent).then(res => {
        if (res.status == 200) {
          return _this.$dialog.toast({ mes: "报名成功" });
        }
      });
    },
    // 获取用户信息
    signUser: function() {
      let that = this;
      postSignUser({ sign: 1 }).then(res => {
        that.userInfo = res.data;
      });
    },
    birthdayType: function(e) {
      this.adultStudent.birthday = e;
    },
    getStudentlist() {
      var _this = this,
        id = this.userInfo.uid;
      getstudentInfo(id).then(res => {
        if (res.status == 200) {
          _this.studentList = res.data.student;
        }
      });
    },
    childSubmit() {
      var _this = this;
      if (this.childStudent.sid == 0)
        return this.$dialog.toast({ mes: "缺少学员" });
      if (this.childStudent.pid == 0)
        return this.$dialog.toast({ mes: "缺少课程" });
      oldBuyLesson(this.childStudent)
        .then(res => {
          if (res.status == 200) {
            _this.$dialog.toast({ mes: "报名成功" });
          }
        })
        .catch(err => {
          _this.$dialog.toast({ mes: err.msg });
        });
    }
  },
  mounted: function() {
    var _this = this;
    this.signUser();
    getLesson().then(res => {
      if (res.status == 200) {
        return (_this.productList = res.data.lesson);
      }
    });
  },
  watch: {}
};
</script>
